
import { IconHexagon } from "@tabler/icons-react";
import { Slugs } from "../User";
import IconCloud from "./magicui/icon-cloud";

export function Loader() {
  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center bg-bgColor animate-fadeIn overflow-hidden">
      
      <div className="animate-cloudFloat">
        <IconCloud iconSlugs={Slugs} />
      </div>

      <div className="absolute flex items-center justify-center animate-pulsatingGlow">
        {/* <IconHexagon
          className="animate-spin-slow text-primaryColor"
          size={130}
          stroke={1.25}
        /> */}
        <div className="absolute font-mono text-primaryColor font-semibold text-6xl">
          Jeevs
        </div>
      </div>
      
      {/* ADDED: The quote with a fade-up animation */}
      <div className="absolute bottom-[25%] font-mono text-center text-textColor text-lg animate-fadeInUp">
        <p>"The future is not something we enter.</p>
        <p>The future is something we create."</p>
      </div>

    </div>
  );
}